<!--
	作者：masonchen
	时间：2017-04-11
	描述：canvas画进度条
--><template>
	<div class="bar">
		<canvas id="progressBar" width=900 height=60></canvas>
	</div>
</template>

<script>
	export default{
		name: "ProgressBar",
		data() {
			return {
				canvas: {},
				context: {},
				isMouseDown: false,
				progress: 0
			}
		},
		mounted() {
			this.init();
			var self = this;
			window.onresize = function(){
				self.canvas.width = document.body.clientWidth * 0.6;
				self.init();
			}
			this.play();
		},
		methods: {
			init (){
				var canvas = document.getElementById("progressBar");
				canvas.width = document.body.clientWidth * 0.6;
				this.$set(this,"canvas",canvas);
				
				if(canvas == null) return;
				var context = canvas.getContext("2d");
				this.$set(this,"context",context);
				
				var self = this;
				
				canvas.addEventListener('mousedown', function(e) {
					console.log("mousedown");
					var p = self.getEventPosition(e);
					if(context.isPointInPath(p.x,p.y)){
						self.isMouseDown = true;
					}
				}, false);
				canvas.addEventListener('mousemove', function(e) {
					var p = self.getEventPosition(e);
				//	console.log("p.x" + p.x);
				//	console.log("p.y" + p.y);
				//	console.log("self.isMouseDown" + self.isMouseDown);
					if(self.isMouseDown){
						self.draw(p);
					}
				}, false);
				canvas.addEventListener('mouseup', function(e) {
					self.isMouseDown = false;
					console.log("mousemove");
				}, false);
				this.draw();
			},
			getEventPosition(ev) {
				var x, y;
//				if(ev.layerX || ev.layerX == 0) {
//					x = ev.layerX;
//					y = ev.layerY;
//				}
//				else
				if(ev.offsetX || ev.offsetX == 0) { // Opera
					x = ev.offsetX;
					y = ev.offsetY;
				}
				return { x: x, y: y };
			},
			draw(p){
				var w = this.canvas.width;
				var h = this.canvas.height;
				var wb = w / 26;
				var hb = 10;
				
				var context = this.context;
				context.clearRect(0,0,w,h);
				for(var i = 0; i < 24; i++) {
					var startX = wb * (i + 1);
					// 画进度条背景
					context.fillStyle = "rgba(233,233,233,1)";
					context.fillRect(startX, 25, wb, hb);
					// 画半小时分割线
					context.fillStyle = "rgba(220,220,220,1)"
					context.fillRect(startX + wb / 2, 25, 1, 10);
					// 画1小时分割线
					context.fillStyle = "rgba(208,208,208,1)"
					context.fillRect(startX, 25, 1, 10);
					// 画数字
					var txt = i;
					context.fillStyle = "#888888"
					context.font = "bold 10px serif";
					context.textBaseline = 'top';
					context.fillText(txt, startX - 2, 36);
				}
				
				p = p || {x:wb,y:h/2};
				if(p.x < wb) p.x = wb;
				if(p.x > wb*25) p.x = wb*25;
				
				context.fillStyle = 'rgba(26,179,149,0.4)';
				context.fillRect(wb, 25, p.x - wb, 10);
				
				context.beginPath();
				context.arc(p.x, h / 2, 8, 0, Math.PI * 2, true);
				this.progress = p.x - wb;
				context.closePath();
				context.fillStyle = 'rgba(26,179,149,1)';
				context.fill();
			},
			// 播放
			play(){
				var self = this;
				var w = this.canvas.width;
				var	h = this.canvas.height;
				var wb = w / 26;
				var	hb = 10;
				var step = 1;
				
				setInterval(function(){
					if(self.isMouseDown) return;
					self.progress += step;
					self.draw({x:wb+self.progress,y:0});
				},15);
			}
		}
	}
</script>

<style scoped>
	.bar {
		z-index:100;
		position: absolute;
		width: 60%;
		height: 60px;
		background: white;
		bottom: 50px;
		right: 50px;
		box-shadow: 3px 3px 5px #888888;
	}
</style>


// WEBPACK FOOTER //
// ProgressBar.vue?60b1cdf6